import { useFormikContext } from "formik";
import { useCallback } from "react";
import { FormInput, FormInputProps } from "src/components/Inputs/FormInput";
import { useEditFormTemplateContext } from "src/scenes/orgAdmin/formTemplates/ContentTab/V1/context";
import { FormType } from "src/scenes/orgAdmin/formTemplates/ContentTab/V1/formik";
import * as Draft from "src/scenes/orgAdmin/formTemplates/types/draft";

interface QuestionKeyProps extends FormInputProps {
  questionId: uuid;
  otherQuestions: readonly Draft.Question[];
}

export function QuestionKey(props: QuestionKeyProps) {
  const { questionId, otherQuestions, ...formInputProps } = props;
  const { formTemplateVersion } = useEditFormTemplateContext();
  const isV2FormTemplate = formTemplateVersion === "2.0.0";

  const form = useFormikContext<FormType>();
  const error = form.touched.questionKeys?.[questionId]
    ? form.errors.questionKeys?.[questionId]
    : undefined;

  const handleChange = useCallback(
    (value: string) => {
      form.setTouched({
        ...form.touched,
        questionKeys: { ...form.touched.questionKeys, [questionId]: true },
      });

      form.setValues((values) => ({
        ...values,
        questionKeys: {
          ...values.questionKeys,
          [questionId]: value,
        },
      }));
    },

    [form, questionId]
  );
  const questionKey = form.values.questionKeys[questionId] ?? "";
  return (
    <FormInput
      {...formInputProps}
      error={error}
      label={isV2FormTemplate ? "Question key" : "Question key (optional)"}
      onChange={async (event) => {
        const value = event.target.value;
        handleChange(value);
      }}
      placeholder="E.g.: reference-value"
      value={questionKey}
    />
  );
}
